import { ProductPagePaymentMethodIcon } from 'shared-types'
import { usePage } from '~/hooks'
import styles from './ProductDashboardPaymentMethods.module.scss'

export const ProductDashboardPaymentMethods = () => {
  const { productPageConfiguration } = usePage()
  const paymentMethodIcons = (
    productPageConfiguration?.paymentMethodIcons || []
  ).filter((paymentMethodIcon) => {
    return Boolean(paymentMethodIcon?.iconUrl)
  })

  if (!paymentMethodIcons.length) {
    return null
  }

  const renderIcon = (paymentMethodIcon: ProductPagePaymentMethodIcon) => {
    const image = (
      <img
        src={paymentMethodIcon.iconUrl}
        alt={paymentMethodIcon.altText || ''}
        className={styles.icon}
        loading='lazy'
      />
    )

    if (!paymentMethodIcon.url) {
      return image
    }

    return (
      <a
        href={paymentMethodIcon.url}
        target='_blank'
        rel='noopener noreferrer'
        className={styles.link}
        aria-label={paymentMethodIcon.altText}>
        {image}
      </a>
    )
  }

  return (
    <div className={styles.root}>
      <ul className={styles.list}>
        {paymentMethodIcons.map((paymentMethodIcon, index) => {
          return (
            <li
              key={`${paymentMethodIcon.iconUrl}-${index}`}
              className={styles.item}>
              {renderIcon(paymentMethodIcon)}
            </li>
          )
        })}
      </ul>
    </div>
  )
}
